import React from 'react';
import PropTypes from 'prop-types';

function formattedAddress(selectedAddress) {
    return `${selectedAddress.street}, ${selectedAddress.city}, ${selectedAddress.state} ${selectedAddress.zipCode}`;
}

function formattedLocation(selectedAddress){
    return selectedAddress.city && selectedAddress.zipCode ? `${selectedAddress.city}, ${selectedAddress.zipCode}` : selectedAddress.zipCode;
}

const FormattedAddress = ({ shoppingLocationResponse }) => {
    let isSelectedAddress =  shoppingLocationResponse.id > 0 || shoppingLocationResponse.addressRecID > 0;

    return (
        <>
            {isSelectedAddress ? formattedAddress(shoppingLocationResponse) : formattedLocation(shoppingLocationResponse)}
        </>
    );

};

FormattedAddress.propTypes = {
    shoppingLocationResponse: PropTypes.shape({
        addressName: PropTypes.string,
        addressRecID: PropTypes.number,
        attention: PropTypes.string,
        city: PropTypes.string,
        dlvModeId: PropTypes.string,
        mbsAltAddressRecId: PropTypes.number,
        phoneNumber: PropTypes.string,
        state: PropTypes.string,
        street: PropTypes.string,
        zipCode: PropTypes.string
    })
};

export default FormattedAddress;